// src/hooks/useOwnerAppeals.ts — server-backed appeals queue hook.
import { useOwnerList } from './useOwnerList';
import { ownerService } from '@/core/services/ownerService';

export function useOwnerAppeals(status = 'pending') {
  return useOwnerList(() => ownerService.getAppeals(status));
}
